import {
  Button,
  CloseButton,
  Flex,
  Heading,
  Modal,
  Spinner,
} from "@instructure/ui";
import { t } from "i18next";
import { useState } from "react";
import { UserService } from "../../services/UserService";
import { ERROR, useNotification } from "../CustomHooks/NotificationProvider";
import { MULTI, Selector } from "../Selectors/Selector";

const DepartmentAssociationModal = ({
  open,
  setOpen,
  departments,
  userInfo,
}) => {
  const showNotification = useNotification();
  const [selectedDepartments, setSelectedDepartments] = useState(
    userInfo.departments
  );
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      await UserService.setAcSubjects(userInfo.canvasId, selectedDepartments);
      showNotification(t("notifications.user.subjectUpdateSuccess"));
      userInfo.departments = selectedDepartments;
      setOpen(false);
    } catch {
      showNotification(t("notifications.user.subjectUpdateError"), ERROR);
    } finally {
      setSubmitting(false);
    }
  };

  const handleDepartmentSelect = (selectedDeptIds) => {
    setSelectedDepartments(selectedDeptIds);
  };

  return (
    <Modal
      open={open}
      size="medium"
      label={t("user.manageDepartmentModalLabel")}
      onDismiss={() => setOpen(false)}
    >
      <Modal.Header>
        <Flex justifyItems="space-between">
          <Flex.Item>
            <Heading level="h2" as="h1">
              {t("user.manageDepartmentAssociations")}
            </Heading>
          </Flex.Item>
          <Flex.Item>
            <CloseButton
              offset="small"
              onClick={() => setOpen(false)}
              screenReaderLabel={t("global.close")}
            />
          </Flex.Item>
        </Flex>
      </Modal.Header>
      <Modal.Body>
        <Selector
          type={MULTI}
          id={"departmentSelector" + userInfo.canvasId}
          label={t("subject.selector")}
          options={departments}
          selectHandler={handleDepartmentSelect}
          selectedOptions={userInfo.departments}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => setOpen(false)} margin="0 x-small 0 0">
          {t("global.cancel")}
        </Button>
        <Button color="primary" type="button" onClick={handleSubmit}>
          {submitting ? (
            <Spinner renderTitle={t("global.pleaseWait")} size="x-small" />
          ) : (
            t("global.save")
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DepartmentAssociationModal;
